import { Box } from '@mui/material';
import CookieConsent from 'react-cookie-consent';
import { useTheme } from '@mui/material/styles';
import { FC, ReactNode } from 'react';
import { IUser } from '../../types/User.interface';
import SiteStatus from '../SiteStatus';
import TimezoneNotificationBanner from '../TimezoneNotificationBanner';

interface MainContentProps {
    user: IUser | null;
    children: ReactNode;
}

const MainContent: FC<MainContentProps> = ({ children, user }) => {
    const theme = useTheme();

    return (
        <>
            <Box
                component={'main'}
                sx={{
                    paddingTop: { xs: '56px', sm: '64px' },
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: theme.palette.background.default,
                }}
            >
                <SiteStatus />
                {user && <TimezoneNotificationBanner />}

                {children}
            </Box>
            <CookieConsent
                location="bottom"
                buttonText="Got it"
                cookieName="callmartCookie"
                style={{ background: 'var(--darkGrey)', zIndex: '99999' }}
                buttonStyle={{
                    color: 'var(--black)',
                    background: 'var(--grey)',
                    fontSize: '18px',
                    borderRadius: '5px',
                    padding: '10px',
                }}
                expires={150}
            >
                This website uses cookies to enhance the user experience.{' '}
            </CookieConsent>
        </>
    );
};

export default MainContent;
